// Sets formstate on submit of each individual step

const EMBED_TYPE = {
  EMBED_TYPE_TOUR: 'virtual-tour',
  EMBED_TYPE_IWC: 'iwc',
  EMBED_TYPE_STANDALONE: 'standalone',
};

export default EMBED_TYPE;
